module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Symptomcodes","subtitle":"Wählen Sie zwischen 1 und 5 Einträge aus.","selected-defects-counter":"Ausgewählt:","error-alert":{"01":"Bitte wählen Sie mindestens ein Defekt aus","02":"Sie können maximal 5 Defekte auswählen"},"input-other-defects-label":"Anderer Fehler / Allgemeine Bemerkungen","select-condition-code-label":"Zustandcode"},"en":{},"it":{},"fr":{}}')
  delete Component.options._Ctor
}
